import type { StateEnum } from '../../__generated__/graphql-client-types';

const NON_CONTIGUOUS_STATES: StateEnum[] = ['AK', 'HI'];

export const isContiguousState = (state: StateEnum): boolean => {
	return !NON_CONTIGUOUS_STATES.includes(state);
};
